<template>
  <div
      :class="{day: true, populated: isPopulated, active: isActive, bordered: isBordered}"
      @click="selectDay()">
    {{day ? day.day : ''}}
  </div>
</template>
<script>
  export default {
    props: {
      day: {
        type: Object,
        required: false
      },
      activeDateFilter: {
        required: false
      },
      isIframe: {
        type: Boolean,
        required: false
      },
      isFullWidth: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      isActive() {
        if (!this.day) {
          return false;
        }
        return this.activeDateFilter === this.day.formatted_date;
      },
      isBordered() {
        if (this.isActive || !this.isPopulated) {
          return false;
        }
        return !!this.activeDateFilter;
      },
      isPopulated() {
        return this.day && this.day.value;
      }
    },
    methods: {
      selectDay() {
        if (!this.isPopulated) {
          return;
        }
        if (this.isIframe) {
          this.$emit('addToFilters', {
            key: 'single_date',
            value: this.day.formatted_date
          });
          let url = new URL(window.location.href);
          url.searchParams.delete('fw')
          url.searchParams.delete('if')
          return window.top.location = url.href;
        }
        if (this.isActive) {
          return this.$emit('removeFilter', 'single_date');
        }
        this.activateDay();
      },
      activateDay() {
        this.$emit('addToFilters', {
          key: 'single_date',
          value: this.day.formatted_date
        });
        this.$emit('loadCourseResults', {
          single_date: this.day.formatted_date
        });
        var courseList = document.getElementById("course-list");

        if (courseList) {
          courseList.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  };
</script>
